export const productStatus = (value) => {
  const status = {
    '1': '待付款',
    '2': '待审核',
    '4': '已失效',
    '5': '使用中'
  }
  return status[value] || '其他状态'
}

export const remainingQuota = (product) => {
  const total = Number(product.reqtotal) || 0
  const used = Number(product.reqused) || 0
  return Math.max(total - used, 0)
}
